import Account from '../libs/api/account';
import StaticContent from '../libs/api/static-content';
import Content from '../libs/api/content';
import Navigation from '../libs/api/navigation';
import Addresses from '../libs/api/addresses';
import Auth from '../libs/api/auth';
import SignUp from '../libs/api/sign-up';
import Payment from '../libs/api/payment';
import Gamifications from '../libs/api/gamifications';
import Questionnaire from '../libs/api/questionnaire';
import StudentProfile from '../libs/api/student-profile';
import Certificate from '../libs/api/certificate';
import StudentPanel from '../libs/api/student-panel';
import Terms from '../libs/api/terms';

export default ({ $axios }, inject) => {
  inject('api', {
    addresses: Addresses($axios),
    account: Account($axios),
    auth: Auth($axios),
    content: Content($axios),
    questionnaire: Questionnaire($axios),
    navigation: Navigation($axios),
    payment: Payment($axios),
    signup: SignUp($axios),
    staticContent: StaticContent($axios),
    StudentProfile: StudentProfile($axios),
    gamifications: Gamifications($axios),
    certificate: Certificate($axios),
    studentPanel: StudentPanel($axios),
    terms: Terms($axios)
  });
};
